import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {
  public pageTitleText:'Course Details';
  imageSrc:string='assets/images/course.jpeg';
  constructor() { }

  ngOnInit(): void {
  }

}
